import type { LocalDate, LocalTime } from '../util/datetime';

/**
 * Ubicación elegida. Una zona con nombre siempre está disponible; las coordenadas solo se
 * ofrecen si el navegador concedió el permiso de geolocalización y devolvió una posición real.
 */
export type LocationOption =
  | { readonly kind: 'NAMED'; readonly id: string; readonly label: string }
  | {
      readonly kind: 'COORDINATES';
      readonly latitude: number;
      readonly longitude: number;
      readonly label: string;
    };

export const DEFAULT_LOCATION: LocationOption = {
  kind: 'NAMED',
  id: 'cdmx',
  label: 'Ciudad de México',
};

export interface SearchFilters {
  readonly cuisines: readonly string[];
  /** Niveles de precio 1..4 seleccionados. Vacío = sin filtrar. */
  readonly priceLevels: readonly number[];
  readonly minRating: number | null;
  readonly maxDistanceMeters: number | null;
  readonly onlyWithAvailability: boolean;
  readonly amenities: readonly string[];
}

export const EMPTY_FILTERS: SearchFilters = {
  cuisines: [],
  priceLevels: [],
  minRating: null,
  maxDistanceMeters: null,
  onlyWithAvailability: false,
  amenities: [],
};

export function activeFilterCount(filters: SearchFilters): number {
  return (
    filters.cuisines.length +
    filters.priceLevels.length +
    filters.amenities.length +
    (filters.minRating !== null ? 1 : 0) +
    (filters.maxDistanceMeters !== null ? 1 : 0) +
    (filters.onlyWithAvailability ? 1 : 0)
  );
}

export function filtersAreEmpty(filters: SearchFilters): boolean {
  return activeFilterCount(filters) === 0;
}

export type SortOption = 'RELEVANCE' | 'RATING' | 'DISTANCE' | 'PRICE_LOW' | 'PRICE_HIGH';

/**
 * Criterios de búsqueda. Los cuatro ejes (ubicación, fecha, hora, personas) siempre tienen
 * valor: sin ellos el servidor no puede responder disponibilidad y la pantalla quedaría en un
 * estado indefinido.
 */
export interface SearchCriteria {
  readonly query: string;
  readonly location: LocationOption;
  readonly date: LocalDate;
  readonly time: LocalTime;
  readonly partySize: number;
  readonly filters: SearchFilters;
  readonly sort: SortOption;
}

export interface UserProfile {
  readonly id: string;
  readonly fullName: string;
  readonly email: string;
  readonly phone: string | null;
  readonly favoriteCuisines: readonly string[];
  readonly defaultPartySize: number | null;
}
